import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { istHandterminalModus } from './handterminal';
import { Handterminal } from './komponenten/Handterminal';
import { Kuechenmonitor } from './komponenten/Kuechenmonitor';
import { Kundenanzeige } from './komponenten/Kundenanzeige';
import './styles.css';

/** `?anzeige=1`: Kundenanzeige für ein zweites Fenster am kundenseitigen Bildschirm. */
const parameter = new URLSearchParams(window.location.search);
const kundenanzeige = parameter.get('anzeige') === '1';
/** `?kueche=1`: Küchenmonitor für Küche oder Schank. */
const kuechenmonitor = parameter.get('kueche') === '1';
/** `?handterminal=1` (danach gemerkt): mobiles Lagergerät ohne Verkauf, eigener Zugang. */
const handterminal = istHandterminalModus(window.location.search, localStorage);

const wurzel = document.getElementById('app');
if (wurzel === null) {
  throw new Error('Element #app fehlt');
}
createRoot(wurzel).render(
  <StrictMode>
    {kundenanzeige ? (
      <Kundenanzeige />
    ) : kuechenmonitor ? (
      <Kuechenmonitor />
    ) : handterminal ? (
      <Handterminal />
    ) : (
      <App />
    )}
  </StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e: unknown) => {
      console.warn('Service Worker nicht registriert', e);
    });
  });
}
